import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Transfer from './pages/Transfer';
import Exchange from './pages/Exchange';
import Passbook from './pages/Passbook';
import Notifications from './pages/Notifications';
import Profile from './pages/Profile';
import Grades from './pages/Grades';
import ClassFees from './pages/ClassFees';
import Shop from './pages/Shop';
import Announcements from './pages/Announcements';
import Admin from './pages/Admin';
import Layout from './components/Layout';

function App() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  return (
    <Routes>
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />}
      />
      <Route
        path="/*"
        element={
          isAuthenticated ? (
            <Layout>
              <Routes>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/transfer" element={<Transfer />} />
                <Route path="/exchange" element={<Exchange />} />
                <Route path="/passbook" element={<Passbook />} />
                <Route path="/grades" element={<Grades />} />
                <Route path="/class-fees" element={<ClassFees />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/announcements" element={<Announcements />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/" element={<Navigate to="/dashboard" />} />
              </Routes>
            </Layout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />
    </Routes>
  );
}

export default App;
